import {
  TableCell as MUuiTableCell,
  TableContainer as MuiTableContainer,
  TableSortLabel as MuiTableSortLabel,
  withStyles,
} from '@material-ui/core';
import React from 'react';
import { formatDateString, formatInCurrency } from '../formatters';
import { Typography } from '../Typography';
import { TCellProps } from './types';

export const TableSortLabel = React.memo(
  withStyles((theme) => ({
    root: { fontSize: theme.typography.fontSize, fontFamily: theme.typography.h1.fontFamily },
  }))(MuiTableSortLabel),
);
export const TableBodyCell = React.memo(
  withStyles((theme) => ({
    root: {
      padding: '4px',
      borderBottom: 'none',
      fontSize: theme.typography.fontSize,
      fontFamily: theme.typography.fontFamily,
      '&:first-of-type': {
        paddingLeft: '0!important',
      },
    },
  }))(MUuiTableCell),
);
export const TableHeaderCell = React.memo(
  withStyles((theme) => ({
    root: {
      lineHeight: '25px', // because of sort icon
      padding: '4px',
      backgroundColor: 'white',
      fontWeight: 600,
      fontSize: theme.typography.fontSize,
      fontFamily: theme.typography.h1.fontFamily,
      height: 42,
      '&:first-of-type': {
        paddingLeft: '0!important',
      },
    },
  }))(MUuiTableCell),
);

export const TableContainer = React.memo(
  withStyles({ root: { overflowX: 'unset' } })(MuiTableContainer),
);

export const DateCell: React.FC<Pick<TCellProps<string>, 'value'>> = React.memo(({ value }) => (
  <span>{formatDateString(value)}</span>
));

interface BooleanCellProps {
  trueComponent: JSX.Element;
  falseComponent: JSX.Element;
}
export const BooleanCell: React.FC<BooleanCellProps & Pick<TCellProps<boolean>, 'value'>> =
  React.memo(({ value, trueComponent, falseComponent }) =>
    value ? trueComponent : falseComponent,
  );

interface AmountCellProps {
  options: Intl.NumberFormatOptions;
}

export const AmountCell: React.FC<AmountCellProps & Pick<TCellProps<number>, 'value'>> = React.memo(
  ({ value, options }) => <Typography>{formatInCurrency(value, options)}</Typography>,
);
